import script from "./Ai_platformEN.vue?vue&type=script&setup=true&name=Ai_platform&lang=js"
export * from "./Ai_platformEN.vue?vue&type=script&setup=true&name=Ai_platform&lang=js"

import "./Ai_platformEN.vue?vue&type=style&index=0&id=2a211536&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a211536"]])

export default __exports__